import { gql } from '@apollo/client';

export default gql`
  query SolarApimResult($formData: FormDataType!, $wizardData: WizardDataType!) {
    solarApimResult(formData: $formData, wizardData: $wizardData) {
      result {
        success
        leadId
        partners {
          partnerName
          success
        }
      }
      error {
        code
        message
      }
    }
  }
`;
